/* Fuel_12 home discovery rows.
   The section can be placed more than once, so this file can be
   requested more than once. Everything below is idempotent: the module
   guard stops a second run, and each row is marked once it is wired.
   Nothing here reveals the rows. That is the Intelligems class alone. */
(function () {
  if (window.f12HomeCarousel) return;
  window.f12HomeCarousel = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function step(viewport) {
    var track = viewport.querySelector('.f12-row__track');
    var item = track && track.firstElementChild;
    if (!item) return Math.round(viewport.clientWidth * 0.8);
    var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
    var pitch = item.getBoundingClientRect().width + gap;
    if (!pitch) return Math.round(viewport.clientWidth * 0.8);
    /* Move by whole cards, never leaving a card half cut on the left. */
    var per = Math.floor((viewport.clientWidth + gap) / pitch);
    return Math.round(pitch * Math.max(1, per));
  }

  function sync(row) {
    var viewport = row.querySelector('[data-f12-viewport]');
    var nav = row.querySelector('[data-f12-nav]');
    if (!viewport || !nav) return;
    var overflows = viewport.scrollWidth - viewport.clientWidth > 1;
    nav.classList.toggle('f12-row__nav--idle', !overflows);
  }

  /* The theme only wires its ajax add to cart inside the section types it
     registers (featured products, collection list, recommendations). This
     section is not one of them, so without this the card forms post the old
     way and the shopper lands on the cart page instead of getting the
     drawer. Bind the theme's own handler once per form; it is the same
     function every other product grid uses. The data-f12-ajax marker only
     guards this file: if this section type is ever registered in theme.js,
     drop this binding, or every click would add twice. */
  function wireForms(row) {
    if (!(window.theme && typeof window.theme.AddItemToCart === 'function')) return false;
    var forms = row.querySelectorAll('form[action="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].dataset.f12Ajax) continue;
      forms[i].dataset.f12Ajax = '1';
      window.theme.AddItemToCart(forms[i]);
    }
    return true;
  }

  function init(row) {
    if (row.dataset.f12Ready) return;
    var viewport = row.querySelector('[data-f12-viewport]');
    if (!viewport) return;
    row.dataset.f12Ready = '1';

    /* Deferred scripts run in document order. This file is printed by the
       section inside the body, theme.js comes later in the layout, so on a
       first load the handler does not exist yet when this runs.
       DOMContentLoaded fires only after every deferred script has run, so
       it is the earliest safe moment; load stays as the backstop. */
    if (!wireForms(row)) {
      document.addEventListener('DOMContentLoaded', function () {
        wireForms(row);
      });
      window.addEventListener('load', function () {
        wireForms(row);
      });
    }

    row.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-f12-move]');
      if (!button || !row.contains(button)) return;
      var direction = button.getAttribute('data-f12-move') === 'prev' ? -1 : 1;
      viewport.scrollBy({
        left: direction * step(viewport),
        behavior: reduced.matches ? 'auto' : 'smooth'
      });
    });

    /* The row is display:none in Control, so its width is 0 until the
       Intelligems class lands. A size observer re-reads it the moment
       it is revealed, which is also what handles rotation and resize. */
    if (window.ResizeObserver) {
      new window.ResizeObserver(function () {
        sync(row);
      }).observe(viewport);
    } else {
      window.addEventListener('resize', function () {
        sync(row);
      });
    }

    sync(row);
  }

  function initAll(scope) {
    var rows = (scope || document).querySelectorAll('[data-f12-row]');
    for (var i = 0; i < rows.length; i++) init(rows[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme editor: a section reload replaces the markup. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
